
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer/account/forgotpassword",
      function () {
        return require("private-next-pages/customer/account/forgotpassword.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer/account/forgotpassword"])
      });
    }
  